import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import ReactLoading from 'react-loading'
import { deleteLandNote, closeDeleteLandNoteModal } from 'redux/actions/landNotes'

const DeleteModal = ({ isOpen, closeModal, landNote, deleteLandNote, isLoading }) => !landNote ? null : (
  <Modal isOpen={isOpen} fade={false} toggle={closeModal} className="warning">
    <ModalHeader toggle={closeModal}>Eliminar Concepto de Nota</ModalHeader>
    <ModalBody>
      Estás seguro de que quieres borrar este concepto ?
    </ModalBody>
    <ModalFooter>
      <Button disabled={isLoading} color="warning" className="mr-1" onClick={() => deleteLandNote(landNote)}>
        {isLoading && <ReactLoading type="spinningBubbles" color="#fff" height={10} width={10} className="d-inline-block mr-4 ml-2" />}
        Eliminar
      </Button>
      <Button disabled={isLoading} color="primary" onClick={closeModal}>Cancelar</Button>
    </ModalFooter>
  </Modal>
)

DeleteModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  landNote: PropTypes.shape({
    category: PropTypes.shape({
      name: PropTypes.string
    }),
    land: PropTypes.shape({
      name: PropTypes.string
    }),
  }),
  closeModal: PropTypes.func.isRequired,
  deleteLandNote: PropTypes.func.isRequired,
}

const mapStateToProps = ({ landNotes: { openedRemoveNoteFromLandModal, selectedLandNote, deletingLandNote }}) => ({
  isOpen: openedRemoveNoteFromLandModal,
  landNote: selectedLandNote,
  isLoading: deletingLandNote
})

const mapDispatchToProps = dispatch => ({
  deleteLandNote: info => dispatch(deleteLandNote(info)),
  closeModal: () => dispatch(closeDeleteLandNoteModal()),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DeleteModal))
